<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
    <div class="container">
      <div class="row g-0">
          <div class="col-lg-6 col-md-6">
              <ul class="breadcrumb">
                  <li><a routerLink="/">Home</a></li>
                  <li><i class="fa fa-angle-right"></i></li>
                  <li><a routerLink="/events">Events</a></li>
                  <li><i class="fa fa-angle-right"></i></li>
                  <li><a routerLink="/events" fragment="academic">Academic</a></li>
                  <li><i class="fa fa-angle-right"></i></li>
                  <li>Punyatithi of Annabhau Sathe</li>
              </ul>
              <div class="sec-title">
                  <h1><span>Punyatithi of Saahitya Ratna Annabhau Sathe</span></h1>
                  <p>GHRCACS observed the Punyatithi of Saahitya Ratna Annabhau Sathe on Friday, 18th July
                      2025. </p>
              </div>
          </div>
      </div>
      <div class="breadcrumb-overlay overflow-hidden"
          style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna4.webp);">
      </div>
    </div>
  </section>
  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
          <ul  appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna1.webp">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna2.webp">
                  </a>
              </li>
              <li class="grid-item3 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna3.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna3.webp">
                  </a>
              </li>
              <!-- <li class="grid-item4 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna4.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna4.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/saahitya-ratna4.webp">
                  </a>
              </li> -->
          </ul>
      </div>
    </div>
  </section>
</main>
